export default "__VITE_ASSET__KeAGsBLA__"